export default "__VITE_ASSET__Cq652EX8__"